import { Discount as API } from '@src/api/types';
import { generateUser } from '@src/factories';
import { Discount as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.id,
  amount: api.amount,
  code: api.code,
  type: api.type,
  user: api.user ? generateUser(api.user) : undefined,
});

export default Factory;
